module.exports = __webpack_public_path__ + "static/img/hero_shape_4.47c0643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero_shape_4.png
// module id = sMKo
// module chunks = 0